<template>
  <v-container fluid>
    <div v-if="1===2"
         class="d-flex align-center pb-3">
      <div class="display-1">
        {{ user.name }}
      </div>
    </div>

    <profile-toolbar>
    </profile-toolbar>

    <router-view>
    </router-view>
  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import ProfileToolbar from "./components/ProfileToolbar";
export default {
  components: {ProfileToolbar},
  computed: {
    ...mapGetters([
      'user',
    ])
  }
}
</script>
